/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMini,
    ElementsUserMiniFromJSON,
    ElementsUserMiniFromJSONTyped,
    ElementsUserMiniToJSON,
    MediaRootMini,
    MediaRootMiniFromJSON,
    MediaRootMiniFromJSONTyped,
    MediaRootMiniToJSON,
    MediaRootPermission,
    MediaRootPermissionFromJSON,
    MediaRootPermissionFromJSONTyped,
    MediaRootPermissionToJSON,
    VolumeMini,
    VolumeMiniFromJSON,
    VolumeMiniFromJSONTyped,
    VolumeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileReference
 */
export interface MediaFileReference {
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    id: number;
    /**
     * 
     * @type {VolumeMini}
     * @memberof MediaFileReference
     */
    volume?: VolumeMini;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileReference
     */
    readonly info?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileReference
     */
    readonly customFields?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {MediaRootPermission}
     * @memberof MediaFileReference
     */
    resolvedPermission?: MediaRootPermission;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileReference
     */
    readonly parentFile?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {MediaRootMini}
     * @memberof MediaFileReference
     */
    root?: MediaRootMini;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaFileReference
     */
    readonly effectiveCustomFields?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {ElementsUserMini}
     * @memberof MediaFileReference
     */
    modifiedBy?: ElementsUserMini;
    /**
     * 
     * @type {string}
     * @memberof MediaFileReference
     */
    readonly fullPath?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly isShared?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly isExcluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly isHardlink?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly isBookmarked?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly childCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MediaFileReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFileReference
     */
    readonly path?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFileReference
     */
    readonly pathhash?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFileReference
     */
    readonly ancestry?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly isDir?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly totalFiles?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly size?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly mtime?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly present?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly needsRescan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileReference
     */
    readonly isShowroom?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly bundleIndex?: number;
    /**
     * 
     * @type {Date}
     * @memberof MediaFileReference
     */
    readonly modified?: Date;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly parent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaFileReference
     */
    readonly bundle?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaFileReference
     */
    readonly bookmarkedBy?: Array<number>;
}

export function MediaFileReferenceFromJSON(json: any): MediaFileReference {
    return MediaFileReferenceFromJSONTyped(json, false);
}

export function MediaFileReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'volume': !exists(json, 'volume') ? undefined : VolumeMiniFromJSON(json['volume']),
        'info': !exists(json, 'info') ? undefined : json['info'],
        'customFields': !exists(json, 'custom_fields') ? undefined : json['custom_fields'],
        'resolvedPermission': !exists(json, 'resolved_permission') ? undefined : MediaRootPermissionFromJSON(json['resolved_permission']),
        'parentFile': !exists(json, 'parent_file') ? undefined : json['parent_file'],
        'root': !exists(json, 'root') ? undefined : MediaRootMiniFromJSON(json['root']),
        'effectiveCustomFields': !exists(json, 'effective_custom_fields') ? undefined : json['effective_custom_fields'],
        'modifiedBy': !exists(json, 'modified_by') ? undefined : ElementsUserMiniFromJSON(json['modified_by']),
        'fullPath': !exists(json, 'full_path') ? undefined : json['full_path'],
        'isShared': !exists(json, 'is_shared') ? undefined : json['is_shared'],
        'isExcluded': !exists(json, 'is_excluded') ? undefined : json['is_excluded'],
        'isHardlink': !exists(json, 'is_hardlink') ? undefined : json['is_hardlink'],
        'isBookmarked': !exists(json, 'is_bookmarked') ? undefined : json['is_bookmarked'],
        'childCount': !exists(json, 'child_count') ? undefined : json['child_count'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'pathhash': !exists(json, 'pathhash') ? undefined : json['pathhash'],
        'ancestry': !exists(json, 'ancestry') ? undefined : json['ancestry'],
        'isDir': !exists(json, 'is_dir') ? undefined : json['is_dir'],
        'totalFiles': !exists(json, 'total_files') ? undefined : json['total_files'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'mtime': !exists(json, 'mtime') ? undefined : json['mtime'],
        'present': !exists(json, 'present') ? undefined : json['present'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'isShowroom': !exists(json, 'is_showroom') ? undefined : json['is_showroom'],
        'bundleIndex': !exists(json, 'bundle_index') ? undefined : json['bundle_index'],
        'modified': !exists(json, 'modified') ? undefined : (new Date(json['modified'])),
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
        'bundle': !exists(json, 'bundle') ? undefined : json['bundle'],
        'bookmarkedBy': !exists(json, 'bookmarked_by') ? undefined : json['bookmarked_by'],
    };
}

export function MediaFileReferenceToJSON(value?: MediaFileReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'volume': VolumeMiniToJSON(value.volume),
        'resolved_permission': MediaRootPermissionToJSON(value.resolvedPermission),
        'root': MediaRootMiniToJSON(value.root),
        'modified_by': ElementsUserMiniToJSON(value.modifiedBy),
    };
}


